/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint no-unused-vars: "off"*/
import React, {useEffect, useState} from 'react';
import MapBase from "./MapBase";
import {PALETTE_YlOrRd_9, TRANSPARENT_COLOR} from "../../utils/Palette";
import useMapProps from "./useMapProps";
import {MapPropsProvider} from "./MapPropsContext";
import WidgetContainer from "./widgets/WidgetContainer";
import {arrayToRgb, getApiUrl, getLastYear, makeTableSorterFn, numberWithCommas} from "../../utils";
import RMateChartSpecificAma from "./r_mate_chart/RMateChartSpecificAma";
import WidgetAmateurStats from "./widgets/WidgetAmateurStats";
import WidgetLegend from "./widgets/WidgetLegend";
import Seperator from "./widgets/Seperator";
import WidgetStatisticsTable from "./widgets/WidgetStatisticsTable";
import WidgetSelectYear from "./widgets/WidgetSelectYear";
import WidgetRisingTabs from "./widgets/WidgetRisingTabs";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import WidgetToolbar from "./widgets/WidgetToolbar";
import {WELL_KNOWN_POSITION} from "../../Constants";
import AlignRightText from "./widgets/AlignRightText";

function MapSpecificAma() {

  const [fillColorLegend, setFillColorLegend] = useState([]);
  const [searchYear, setSearchYear] = useState("");

  const mapProps = useMapProps({
    INITIAL_VIEW_STATE: {
      ...WELL_KNOWN_POSITION.세종특별자치시,
      zoom: 8,
    },
    INITIAL_GEOJSON_EXTRA_PARAMS: {
      year: getLastYear(),
      month: 12,
      currentDistrictCode: '',
    },
    INITIAL_GEOJSON_POLYGON_LAYER_PROPS: {
      getHoverHtml: (object, mapDistrictStats) => {
        const [metricObject] = mapDistrictStats;
        const {properties: {pk, name}} = object;
        const code = pk;
        const obj = metricObject[code];
        if (obj) {
          const {total} = obj;
          return `<span class='fontStyle'>${name}</span><br/> 
                아마추어무선국 수 : ${numberWithCommas(total)}개<br/>`;
        }
        // metricObject에 없더라도 호버를 띄워줍니다.
        return `<span class='fontStyle'>${name}</span><br/> 
                아마추어무선국 수 : 0개<br/>`;
      },
      getLevelFillColor: ({properties: {pk}}, mapDistrictStats) => {
        const [metricObject, metricMax] = mapDistrictStats;
        const code = pk;
        const obj = metricObject[code];
        // 데이터가 없더라도 색을 입힙니다.
        if (obj) {
          const {total} = (metricObject[code] || {total: 1});
          if (total >= 1) {
            const index = Math.floor(PALETTE_YlOrRd_9.length * (total - 1) / metricMax);
            return PALETTE_YlOrRd_9[index];
          }
          return TRANSPARENT_COLOR;
        }
        return TRANSPARENT_COLOR;
      },
    },
    INITIAL_WIDGET_STATE: {
      range_code_stats_list: ["HF", "VHF", "UHF", "OTHER"],
    }
  });

  /*
   서버 Ajax 통신을 위해 json을 만듭니다.
  */

  const settingChkRadSvcString = (checkList) => {
    // as-is 의 json 통신을 위한 문자열 만들기
    let JSONList = {
      "data": []
    };

    for (let value of checkList) {
      const jsonValue = {"CHK_VALUE": value};
      JSONList.data.push(jsonValue);
    }
    return JSON.stringify(JSONList);
  };
// 차트 색을 입히기 위해 라벨 array를 만듭니다.
  const settingLabelListforRange = (rangeList) => {

    let labelList = [];
    for (let rangeCode of rangeList) {
      if (rangeCode === 'HF') labelList.push("HF");
      else if (rangeCode === 'VHF') labelList.push("VHF");
      else if (rangeCode === 'UHF') labelList.push("UHF");
      else if (rangeCode === 'OTHER') labelList.push("기타");
    }
    return labelList;
  };
  // --- 서버 통신을 위한 함수 끝

  const {
    widgetState,
    dataResponseList,
    mapDistrictStats, setMapDistrictStats, isChangedMapDistrictStats,
    clickedPolygonGeojsonObjects,
    geojsonExtraParams,
    currentDistrictCode,
    setGeojsonExtraParams,
    setCurrentDistrictCode,
    setChartAjaxParams,
    setTableAjaxParams,
  } = mapProps;

  useEffect(() => {
    const {
      range_code_stats_list
    } = widgetState;

    // {"11110": {"HF": 61, "OTHER": 14, "UHF": 91, "VHF": 151},
    const metricObject = {};
    if (dataResponseList.length > 0) {
      const firstDataLayer = dataResponseList[0];
      for (let [code, stats] of Object.entries(firstDataLayer)) {
        let total = 0;
        // eslint-disable-next-line no-unused-vars
        for (let [checkCode, stat] of Object.entries(stats)) {
          if (range_code_stats_list.includes(checkCode)) {
            const codeVal = firstDataLayer[code][checkCode];
            total += codeVal;
          }
        }
        if( code !== '99') metricObject[code] = {total};

      }
    }

    const metricMax = Math.max(...Object.values(metricObject).map(obj => obj.total));

    const newMapDistrictStats = [metricObject, metricMax];
    if ( isChangedMapDistrictStats(newMapDistrictStats) ) {
      setMapDistrictStats(newMapDistrictStats);

      ////////// ajax new_param 설정////////////
      // 년도 세팅
      const {year} = geojsonExtraParams;
      setSearchYear(year);
      window.searchYear = year.toString();

      // json 문자열
      window.chkString01 = settingChkRadSvcString(range_code_stats_list);

      // 파라미터 배열
      window.prm_check = range_code_stats_list;

      window.sidoCode = (currentDistrictCode || '').length < 2
        ? ''
        : currentDistrictCode.substr(0, 2);


      setChartAjaxParams({
        sidoCode        : window.sidoCode,
        searchYear      : window.searchYear,
        chkString01     : settingChkRadSvcString(range_code_stats_list),
        prm_check       : range_code_stats_list,
        prm_check_label : settingLabelListforRange(range_code_stats_list),
      });
    }
  }, [dataResponseList, widgetState, geojsonExtraParams, currentDistrictCode]);

  useEffect(() => {
    if (clickedPolygonGeojsonObjects.length > 0) {
      const firstLayer = clickedPolygonGeojsonObjects[0];
      const {properties: {name, pk}} = firstLayer;
      if ((pk || '').length <= 2) {
        setCurrentDistrictCode(pk);
      }
    }
  }, [clickedPolygonGeojsonObjects]);

  useEffect(() => {
    const [metricObject, metricMax] = mapDistrictStats;
    if (window.isFinite(metricMax) && metricMax >= 9) {
      setFillColorLegend(
        [...Array(9).keys()].map(colorIndex => {
          const boundary = (metricMax / 9) * (colorIndex + 1);
          const index = Math.floor(PALETTE_YlOrRd_9.length * (boundary - 1) / metricMax);
          const colorRgb = arrayToRgb(PALETTE_YlOrRd_9[index]);
          return [colorRgb, boundary];
        }).reverse()
      );
    } else { // 데이터가 없을때
      setFillColorLegend(
        [...Array(1).keys()].map(colorIndex => {
          const boundary = 0;
          const colorRgb = '#ffffd9';
          return [colorRgb, boundary];
        }).reverse()
      );
    }
  }, [mapDistrictStats]);

  useEffect(() => {
    setGeojsonExtraParams(prev => ({
      ...prev,
      currentDistrictCode,
    }));
  }, [currentDistrictCode]);

  useEffect(() => {
    setTableAjaxParams({
      sidoCode: (currentDistrictCode || ''),
      searchEnd: searchYear,
    })
  }, [currentDistrictCode, searchYear]);

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase isHideWidgetToggleClustering={true} isHideWidgetMapLayerTypes={true}>
        <WidgetContainer>
          <div>
            <WidgetDistrictSelect isShowDistrictLayerFromGeoserver={true} onlyLv1={true} />
            <WidgetSelectYear/>
            <Seperator/>
            <WidgetAmateurStats />
          </div>
        </WidgetContainer>
      </MapBase>

      <WidgetRisingTabs titleOnInit={["년도별 아마추어 무선국", "지역별 아마추어 무선국"]}>
        <WidgetStatisticsTable
          fetchUrl={getApiUrl({type: "type3"})}
          type={"type3"}
          getTitle={(layer) => `년도별 아마추어 무선국`}
          processor={objectList => {
            const rowList = objectList.map(row => {
              const {year} = row;
              const yearString = year.concat('년');
              return {...row, 'year': yearString};
            })
            const columns = [];
            return [columns, rowList];
          }}
          columns={[
            {title: '년도', dataIndex: 'year', key: 'year', width: 120, fixed: 'left' , sorter: makeTableSorterFn('year')},
            {title: '합계', dataIndex: 'data_sum_cnt', key: 'data_sum_cnt',
              render: value => AlignRightText({ text: value, numberComma: true })
            },
            {title: 'HF', dataIndex: 'data_hf_cnt', key: 'data_hf_cnt',
              render: value => AlignRightText({ text: value, numberComma: true })},
            {title: 'VHF', dataIndex: 'data_vhf_cnt', key: 'data_vhf_cnt',
              render: value => AlignRightText({ text: value, numberComma: true })},
            {title: 'UHF', dataIndex: 'data_uhf_cnt', key: 'data_uhf_cnt',
              render: value => AlignRightText({ text: value, numberComma: true })},
            {title: 'OTHER', dataIndex: 'data_other_cnt', key: 'data_other_cnt',
              render: value => AlignRightText({ text: value, numberComma: true })},
          ]}
        />
        <WidgetStatisticsTable
          fetchUrl={getApiUrl({ type: "type1" })}
          type={"type1"}
          getTitle={(layer) => `지역별 아마추어 무선국`}
          columns={[
            {title: '지역명', dataIndex: 'gubun_nm', key: 'gubun_nm', width: 120, fixed: 'left'},
            {title: '합계', dataIndex: 'data_sum_cnt', key: 'data_sum_cnt',
              render: value => AlignRightText({ text: value, numberComma: true })},
            {title: 'HF', dataIndex: 'data_hf_cnt', key: 'data_hf_cnt',
              render: value => AlignRightText({ text: value, numberComma: true })},
            {title: 'VHF', dataIndex: 'data_vhf_cnt', key: 'data_vhf_cnt',
              render: value => AlignRightText({ text: value, numberComma: true })},
            {title: 'UHF', dataIndex: 'data_uhf_cnt', key: 'data_uhf_cnt',
              render: value => AlignRightText({ text: value, numberComma: true })},
            {title: 'OTHER', dataIndex: 'data_other_cnt', key: 'data_other_cnt',
              render: value => AlignRightText({ text: value, numberComma: true })},
          ]}
        />
      </WidgetRisingTabs>

      <RMateChartSpecificAma disabled={
        widgetState.range_code_stats_list.length === 0
      }/>
      {fillColorLegend.length > 0 && <WidgetLegend fillColorLegend={fillColorLegend}  titleColorLegend={'무선국 수'}  unitColorLegend={'개'}/>}
      <WidgetToolbar />
    </MapPropsProvider>
  );
}

export default MapSpecificAma;
